<template>
  <div class="news">
    <div class="headImg">
      <img :src="`http://www.china-tillage.com:8000${headImg}`" alt=""  style="width:100%;"/>
    </div>
    <div class="content">
      <ul>
        <li v-for="(item,index) in newsList" :key="index" @click="toNewsDetail(item.cid,item.gtmCreate)">
          <div class="img"><img :src="`http://www.china-tillage.com:8000${item.pic}`" alt=""></div>
          <div class="articl">
            <p class="title">{{item.title}}</p>
            <p class="text">  
              {{item.summary}}
              <!--  v-html="item.summary" -->
              <!-- 2020年面对严峻复杂的形式特别是新冠肺炎疫情重大影响的挑战和考验，四川省第三产业协会会员单位认真贯彻执行
              党和政府的决策部署，为推动我省第三产业持续健康发展做出突出贡献，经各单位申报，专委会评选，报请协会评选…… -->
            </p>
            <p class="date">{{item.gtmCreate}}</p>
          </div>
        </li>
        <!-- <li>
          <div class="img"></div>
          <div class="articl">
            <p class="title">喜贺公司获得三产协会先进单位称号</p>
            <p class="text">2020年面对严峻复杂的形式特别是新冠肺炎疫情重大影响的挑战和考验，四川省第三产业协会会员单位认真贯彻执行
              党和政府的决策部署，为推动我省第三产业持续健康发展做出突出贡献，经各单位申报，专委会评选，报请协会评选……
            </p>
            <p class="date">2021-05-03</p>
          </div>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { baseURL } from "../../../config.ts"

export default {
  name: 'news',
  data() {
    return {
      headImg: "",
      newsList:[],
      baseURL:null,
    }
  },
  components: {},
  mounted () {
    this.baseURL = baseURL
    this.getNewsLsit()
    this.getheadImg()
  },
  methods: {
    // 获取大图
    getheadImg(){
      this.$http.get(`${baseURL}/json/img/new`).then( (res)=>{
          // console.log(res,"头部图片")
          this.headImg = res.data.pic
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    toNewsDetail(id,time){
      let date = new Date()
      if(Number(time.substring(0,4)) >=date.getFullYear()-1 && Number(time.substring(0,4)) <=date.getFullYear()){
        this.$router.push({path:'/newsDetail',query: { id: id}})
      }
    },
    // 获取新闻中心数据
    getNewsLsit(){
      this.$http.get(`${baseURL}/json/new?page=1&rows=100`).then( (res)=>{
          // console.log(res,"新闻")
          this.newsList = res.data
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
  },
}
</script>

<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.news{
  .headImg {
    width: 100%;
    // height: 656px;
    overflow: hidden;
  }
  .content{
    // width: 60%;
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    ul{
      li{
        height: 200px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
        cursor: pointer;
        div.img{
          width: 250px;
          height: 200px;
          margin-right: 20px;
          overflow: hidden;
          display: flex;
          align-items: center;
          img{
            width: 100%;
            transition: all 0.2s;
          }
        }
        div.img:hover{
          img{
            transform: scale(1.1);
          }
        }
        div.articl{
          // flex: 1;
          width: 940px;
          height: 140px;
          // padding:20px 0; 
          p.title{
            padding: 10px 0;
            font-size: 18px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: bold;
            text-align: left;
            color: #07142b;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p.text{
            height: 120px;
            font-size: 14px;
            text-indent: 28px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #48517f;
            line-height: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          }
          p.date{
            font-size: 12px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #48517f;
            line-height: 20px;
          }
        }
      }
    }
  }
}
</style>
